'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["defaultMode"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import getComponentName from 'react-utils/getComponentName';
import { PopoverBodyMode } from 'rich-text-lib/constants/popover';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withPopoverModeState(WrappedComponent) {
  class PopoverModeState extends Component {
    constructor(props) {
      super(props);
      this.handleModeChange = nextMode => {
        // Toggle mode by default
        if (!nextMode) {
          nextMode = this.state.mode === PopoverBodyMode.PREVIEW ? PopoverBodyMode.EDIT : PopoverBodyMode.PREVIEW;
        }
        if (nextMode !== this.state.mode) {
          this.setState({
            mode: nextMode
          });
        }
      };
      this.state = {
        mode: this.props.defaultMode || PopoverBodyMode.PREVIEW
      };
    }
    render() {
      const _this$props = this.props,
        rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
        mode: this.state.mode,
        onModeChange: this.handleModeChange
      }, rest));
    }
  }
  PopoverModeState.propTypes = {
    defaultMode: PropTypes.string
  };
  PopoverModeState.displayName = `PopoverModeState(${getComponentName(WrappedComponent)})`;
  return PopoverModeState;
}